import { Flex, Empty } from "antd";

import "./EmptyData.style.less";

const EmptyData = ({ description }) => {
  return (
    <Flex align="center" justify="center" className="empty-data">
      <Empty description={description} />
    </Flex>
  );
};

export default EmptyData;
